import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './context/AuthContext'; 

import { GlobalStyles } from '@mui/material';

import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { AnimatePresence } from "framer-motion";
import PageWrapper from "./components/PageWrapper"; 
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/loginPage';
import Membership from './pages/Membership';
import Manageusers from './pages/Managusers';
import Userprofile from './pages/Userprofile';

const theme = createTheme({
  typography: {
    fontFamily: "Poppins, sans-serif",
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          '.MuiAutocomplete-paper': { backgroundColor: '#f8f9e9' },
          '.MuiAutocomplete-option:hover': { backgroundColor: '#eeeeee' },
          '.MuiAutocomplete-option[aria-selected="true"]': { backgroundColor: '#e0e0e0' },
        }}
      />

      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <AnimatePresence mode="wait">
              <Routes>
                {/* District selection + login */}
                <Route path="/" element={<PageWrapper><LoginPage /></PageWrapper>} />

                {/* Dynamic district routes */}
                <Route path="/:district" element={<PageWrapper><LoginPage /></PageWrapper>} />
                <Route path="/:district/membership" element={<PageWrapper><Membership /></PageWrapper>} />
                
                <Route
                  path="/:district/manageusers"
                  element={
                    <ProtectedRoute allowedRoles={['admin', 'superuser']}>
                      <PageWrapper><Manageusers /></PageWrapper>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/:district/userprofile"
                  element={
                    <ProtectedRoute allowedRoles={['admin', 'superuser']}>
                      <PageWrapper><Userprofile /></PageWrapper>
                    </ProtectedRoute>
                  }
                />

                {/* Fallback */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </AnimatePresence>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
